<div
  class="card-skeleton loading"
  [ngStyle]="skeletonStyles"
  *ngIf="isLoading; else card"
></div>

<ng-template #card>
  <div
    class="card"
    [style.box-shadow]="boxShadow"
    [style.border-radius]="borderRadius"
    [ngStyle]="customStyles"
  >
    <slot name="header"></slot>

    <div class="card-content">
      <slot></slot>

      <div class="card-content__body">
        <slot name="content" (slotchange)="slotChangeBody($event)"></slot>
      </div>

      <div class="card-content__extra">
        <slot name="extra-content"></slot>
      </div>
    </div>
  </div>
</ng-template>
